import { createFileRoute } from '@tanstack/react-router'
import { SiteInspectionDeletePage } from '@/features/site-inspections/delete'

export const Route = createFileRoute(
  '/site-inspections_/$siteInspectionId/delete',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { siteInspectionId } = Route.useParams()
  return <SiteInspectionDeletePage siteInspectionId={siteInspectionId} />
}
